(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@ag-grid-community/core"));
	else if(typeof define === 'function' && define.amd)
		define(["@ag-grid-community/core"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("@ag-grid-community/core")) : factory(root["@ag-grid-community/core"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 